module.exports = __webpack_public_path__ + "media/images/real-amber-d665f0bbc4ed07935838bf71adf8614e.png";